import { InstanceLink } from '@/components/routing';
import { Text } from '@/components/typography';
import { cn } from '@/lib/utils';

type Props = {
  name: string;
  value?: string | number | null;
  valueLink?: string | null | false;
  secondaryValue?: string | number | null | false;
  color?: string;
  valueOverflow?: boolean;

  // An unfortunate hack to prevent tooltips from using `Link` components when they're rendered
  // using `renderToStaticMarkup` for Highcharts.
  unstable_hasRouterContext?: boolean;
};

const TooltipRow = ({
  name,
  value,
  valueLink,
  secondaryValue,
  color,
  valueOverflow = false,
  unstable_hasRouterContext = true,
}: Props) => {
  if (value == null) {
    return null;
  }

  const multiLineName = `${name}`.split('<br/>');
  const multiLineValue = `${value}`.split('<br/>');
  const multiLineSecondaryValue = secondaryValue && `${secondaryValue}`.split('<br/>');

  return (
    <tr>
      <td className="content-start px-1.5 pr-0.5 align-middle whitespace-nowrap">
        <div className="flex items-start">
          {color != null && (
            <span
              className="my-1 mr-2 inline-block size-3 shrink-0 rounded-full"
              style={{
                backgroundColor: color,
              }}
            />
          )}
          <div className="min-w-0">
            {multiLineName.map((name) => (
              <Text
                key={name}
                className="block whitespace-nowrap"
                variant="body2"
                color="white"
                weight="regular"
              >
                {name}:
              </Text>
            ))}
          </div>
        </div>
      </td>
      <td className="content-start px-1.5 text-end align-middle">
        {multiLineSecondaryValue &&
          multiLineSecondaryValue.map((val) => (
            <Text key={val} variant="body2" className="block whitespace-nowrap" color="white">
              {val}
            </Text>
          ))}
      </td>
      <td className="content-start px-1.5 text-end align-middle">
        <div
          className={cn('w-full', {
            'mr-2 max-h-25 overflow-y-auto pr-2': valueOverflow,
          })}
        >
          {multiLineValue.map((val) => {
            const isLinked = !!valueLink;

            const content = (
              <Text
                key={val}
                id={!unstable_hasRouterContext && valueLink ? valueLink : undefined}
                variant="body2"
                className="block whitespace-nowrap"
                color="white"
                underline={isLinked}
                pointer={isLinked}
              >
                {val}
              </Text>
            );

            if (isLinked && unstable_hasRouterContext) {
              return (
                <InstanceLink to={valueLink} key={val}>
                  {content}
                </InstanceLink>
              );
            }
            return content;
          })}
        </div>
      </td>
    </tr>
  );
};

export default TooltipRow;
